import { MouseEvent } from 'react'

import { PointCloudOctree } from '@datalabs-jp/three-loader'
import { PointArray } from '@editor/interfaces/attribute'
import { BlueprintV2 } from '@editor/interfaces/blueprint'
import { InspectionArea } from '@editor/interfaces/inspection'
import { getSignedUrlForPotreeFiles } from '@editor/services/InspectionArea'
import { Matrix4, Matrix4Tuple, Points, Vector3 } from 'three'

export const ANCHOR_COLORS = ['#90EE90', '#DA70D6', '#FFA500']

export enum ViewSides {
  Left = 'left',
  Right = 'right',
}

export enum Steps {
  SelectPoints,
  FineTuneOrSave,
}

export enum Tools {
  Overview,
  PCDAlignment,
}

export enum Mode {
  Normal = 'normal',
  Focus = 'focus',
}

export type SignedUrls = Promise<
  | (Awaited<ReturnType<typeof getSignedUrlForPotreeFiles>> & {
      expiry: Date
      inspectionAreaId: string
      blueprintId?: string
    })
  | null
>

export type LoadedPCD = { areaId: string; pcd: Points | PointCloudOctree | null }
export type LoadedPCDs = Promise<LoadedPCD | null>[]

export interface Alignment {
  /**
   * The inspection area being represented.
   */
  area: InspectionArea

  /**
   * The blueprint this PCD belongs to, if any.
   */
  blueprint?: BlueprintV2

  anchors: Vector3[]
  center: Vector3
}

export interface AlignedArea {
  current: Alignment
  other?: Alignment
  matrix: Matrix4
  inverted: boolean
}

/**
 * Redux-safe structure for the AlignedArea data.
 */
export interface AlignmentSerializable {
  area: InspectionArea
  blueprint?: BlueprintV2
  anchors: PointArray[]
  center: PointArray
}
/**
 * Redux-safe structure for the AlignedArea data.
 */
export interface AlignedAreaSerializable {
  current: AlignmentSerializable
  other?: AlignmentSerializable
  matrix: Matrix4Tuple
  inverted: boolean
}

export interface SceneEventHandlers {
  onClick?: (ev: MouseEvent<HTMLDivElement>) => void
  onUp?: (ev: MouseEvent<HTMLDivElement>) => void
  onMove?: (ev: MouseEvent<HTMLDivElement>) => void
  onFocus?: (ev: MouseEvent<HTMLDivElement>) => void
}
